class BsFinanceModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".bs-finance-modal",
      openBtn: "[data-open-finance-modal]"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("bs-finance-content");
          contentElement.innerHTML = this.modalContent;

          this.modal.appendChild(contentElement);
          this.modal.setSizes("bs-finance-modal");
          this.modal.open();
        }
      }
    });
  }
}

customElements.define("bs-finance-modal", BsFinanceModal);
